import React from "react";
import Error from "../error/error";
import Milestone from "./milestone";

const summaryMilestones = props => {
  let mainContent = <p>There are no milestones to display.</p>;

  if (props.summaryMilestones.error)
    mainContent = Error(props.summaryMilestones.error);

  if (props.summaryMilestones.milestones.length > 0) {
    mainContent = (
      <mosaic-status-card-carousel glide>
        {milestoneCards(props.summaryMilestones.milestones)}
      </mosaic-status-card-carousel>
    );
  }

  return (
    <mosaic-col>
      <mosaic-card id={props.cardName}>
        <mosaic-card-body>
          <div>{mainContent}</div>
        </mosaic-card-body>
      </mosaic-card>
    </mosaic-col>
  );
};

const milestoneCards = milestones => {
  let milestoneCounter = 0;

  return milestones.map(milestone => {
    milestoneCounter++;
    const isFirst = milestoneCounter === 1 ? "" : null;
    const isLast = milestoneCounter === milestones.length ? "" : null;

    return (
      <Milestone
        key={milestoneCounter}
        milestone={milestone}
        isFirst={isFirst}
        isLast={isLast}
      />
    );
  });
};

export default summaryMilestones;
